export default {
  // EXAMPLE_ACTION_TYPE: "[mentorRatings] Example Action Type",

  SET_MENTOR_RATING: "[mentorRatings] SET Mentor Rating",

  UPDATE_MENTOR_RATING: "[mentorRatings] Update Mentor Rating",
  // INSERTION_PT (for script, do not remove)
};
